export default function reducer(state, action) {
    switch (action.type) {
        case 'openTestPanel': {
            return {
                ...state,
                isShowTestPanel: true,
            }
        }
        case 'closeTestPanel': {
            return {
                ...state,
                isShowTestPanel: false,
            }
        }
        case 'deviceList': {
            const { cameraList, microphoneList } = action.payload
            return {
                ...state,
                cameraList,
                microphoneList,
            }
        }
        case 'addStream': {
            const { stream } = action.payload
            return {
                ...state,
                stream,
                streamList: [...state.streamList, stream],
            }
        }
        case 'setPermission': {
            const {
                isGrantedCameraPermission,
                isGrantedMicrophonePermission,
            } = action.payload
            return {
                ...state,
                isGrantedCameraPermission,
                isGrantedMicrophonePermission,
            }
        }
        case 'setControlsDisabled': {
            const { controlsDisabled } = action.payload
            return {
                ...state,
                controlsDisabled,
            }
        }
        case 'cameraError': {
            const { cameraError } = action.payload
            return {
                ...state,
                cameraError,
            }
        }
        case 'process': {
            const { process } = action.payload
            return {
                ...state,
                process,
            }
        }
        case 'cameraActive': {
            return {
                ...state,
                isCameraActive: true,
            }
        }
        case 'openSettingDialog': {
            return {
                ...state,
                isShowSettingDialog: true,
            }
        }
        case 'closeSettingDialog': {
            return {
                ...state,
                isShowSettingDialog: false,
            }
        }
        default:
            return {}
    }
}
